'use client'
import React from 'react'
import { THEME_COLOR } from '@dustin-web/microsite-config'
import { ThemeColor } from './theme-color'

const ThemeColorClient = () => {
  return <ThemeColor themeColor={THEME_COLOR} />
}

export default ThemeColorClient
